import React from 'react';

export interface IconFolderProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconFolder: React.FC<IconFolderProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M2 11V4H9L12.5 7H22V11M2 11V20H22V11M2 11H22" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" />  
    </svg>
  );
};

export default IconFolder;
